import "./LatestCardClinicalData.scss";
import clsx from "clsx";
import { Col, Divider, Row } from "@/components";

export type LatestCardClinicalDataProps = {
  className?: string;
  categoryLabel: string;
  effectiveTime?: string;
  entity: string;
  device?: string | null;
  value?: number | null;
  measurementUnit?: string;
  variationValue?: string;
  variationUnit?: string;
  variationStatus?: "normal" | "alert";
};

export const LatestCardClinicalData = ({
  className = "",
  categoryLabel,
  effectiveTime,
  entity,
  device,
  value,
  measurementUnit,
  variationValue,
  variationUnit,
  variationStatus = "normal",
}: LatestCardClinicalDataProps) => {
  const statusColor =
    variationStatus === "alert"
      ? "clinical-data-dot-alert"
      : "clinical-data-dot-normal";

  return (
    <div
      className={clsx(
        "clinical-data-card rounded shadow d-flex flex-column ",
        className,
      )}
    >
      <Row
        className="px-x24 py-x8"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
      >
        <span className="fs-7 fw-semibold text-slate-28">{categoryLabel}</span>
        {effectiveTime && (
          <span className="fs-7 fw-semibold text-slate-28">
            {effectiveTime}
          </span>
        )}
      </Row>
      <Divider bg={"border-divider"} />

      <Row
        className="gap-x16 p-x24 h-full w-full"
        justifyContent="space-between"
        alignItems="flex-end"
        flexWrap="wrap"
      >
        <Col className="gap-x12">
          <h3 className="text-primary fw-semibold fs-5 md-fs-4 mb-0">
            {entity}
          </h3>
          {device && (
            <span className="fs-7 fw-semibold text-white bg-secondary rounded py-x4 px-x16">
              {device}
            </span>
          )}
        </Col>
        <Row
          alignItems="end"
          className="gap-x8 w-full"
          aria-live="polite"
          justifyContent="space-between"
        >
          <div className="d-flex align-items-end gap-x8">
            <p className="text-slate-20 fw-bold fs-1 ">{value ?? "-"}</p>
            {measurementUnit && (
              <p className="text-slate-28 fs-6 ">{measurementUnit}</p>
            )}
          </div>
          {variationValue && (
            <div className="d-flex align-items-center gap-x4">
              <div
                className={clsx("clinical-data-dot", statusColor)}
                aria-hidden="true"
              />
              <p className="fw-bold text-slate-28 fs-6 ">{variationValue}</p>
              {variationUnit && (
                <p className="text-slate-28 fs-6">{variationUnit}</p>
              )}
            </div>
          )}
        </Row>
      </Row>
    </div>
  );
};
